export default {
  namespaced: true,
  actions: {
    create({ commit }, requirement) {
      return Vue.$http.post('admin/requirements', { requirement }).then(
        (response) => commit('admin/opportunities/set', response.data, { root: true }),
        (response) => Object.assign(requirement, response.data) // append errors
      )
    },
    update({ commit }, requirement) {
      return Vue.$http.patch(`admin/requirements/${requirement.id}`, { requirement }).then(
        (response) => commit('admin/opportunities/set', response.data, { root: true }),
        (response) => Object.assign(requirement, response.data) // append errors
      )
    },
    destroy({ commit }, requirement) {
      return Vue.$http.delete(`admin/requirements/${requirement.id}`).then(
        (response) => commit('admin/opportunities/set', response.data, { root: true })
      )
    }
  }
}
